module.exports = __webpack_public_path__ + "images/mdj/members/resume/mobile/desired-a38748d4136e2da9477e506032e0c217.png";